var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('type-based-transition',{attrs:{"transitionType":'fadeUpDown'}},[(_vm.isComplete)?_c('div',{staticClass:"form-complete",attrs:{"id":"complete"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }